import { showAlert } from "../../config/utils";
import { getListForCommonFilter } from "../recommendations/services";
import * as actionTypes from "./constants";
import * as Service from "./services";
import { invalidateDashboardSessionCache, invalidateQueryFiltersForProject } from "../../utils/dashboardSession";

const getDashboard = (param, isAssetDashboard = false) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_DASHBOARD_REQUEST });
            const res = await Service.getDashboard(param, isAssetDashboard);
            if (res && res.status === 200) {
                const codeData = res.data;
                if (codeData.success) {
                    // Asset dashboard requests must return is_asset_dashboard_view or they are ignored
                    if ((isAssetDashboard && !codeData?.is_asset_dashboard_view) || (!isAssetDashboard && codeData?.is_asset_dashboard_view)) {
                        return;
                    }
                    dispatch({
                        type: actionTypes.GET_DASHBOARD_SUCCESS,
                        response: codeData
                    });
                } else {
                    dispatch({ type: actionTypes.GET_DASHBOARD_FAILURE, error: codeData });
                }
            } else {
                dispatch({ type: actionTypes.GET_DASHBOARD_FAILURE, error: res.response.data });
            }
        } catch (e) {
            dispatch({ type: actionTypes.GET_DASHBOARD_FAILURE, error: e.response && e.response.data });
        }
    };
};
const clearDashboardData = () => {
    return async dispatch => {
        dispatch({ type: actionTypes.CLEAR_DASHBOARD_DATA });
    };
};

const getFcaChartExcelExport = params => {
    return async dispatch => {
        try {
            const response = await Service.getFcaChartExcelExport(params);
            const { data } = response;
            const name = response.headers["content-disposition"].split("filename=");
            const fileName = name[1].split('"')[1];
            const downloadUrl = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement("a");
            link.href = downloadUrl;
            link.setAttribute("download", `${fileName}`); //any other extension
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (e) {}
    };
};

const getFciChartExcelExport = params => {
    return async dispatch => {
        try {
            const response = await Service.getFciChartExcelExport(params);
            const { data } = response;
            const name = response.headers["content-disposition"].split("filename=");
            const fileName = name[1].split('"')[1];
            const downloadUrl = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement("a");
            link.href = downloadUrl;
            link.setAttribute("download", `${fileName}`); //any other extension
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (e) {}
    };
};

const getHorizontalChartExport = params => {
    return async dispatch => {
        try {
            const response = await Service.getHorizontalChartExport(params);
            const { data } = response;
            const name = response.headers["content-disposition"].split("filename=");
            const fileName = name[1].split('"')[1];
            const downloadUrl = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement("a");
            link.href = downloadUrl;
            link.setAttribute("download", `${fileName}`); //any other extension
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (e) {}
    };
};

const getChartsDashboardPython = (param, displayType) => {
    return async dispatch => {
        if (displayType === "parallel") {
            try {
                dispatch({ type: actionTypes.GET_DASHBOARD_CHART_PARALLEL_REQUEST });
                const res = await Service.getChartsDashboardPython(param);
                if (res && res.status === 200) {
                    const codeData = res.data;
                    dispatch({ type: actionTypes.GET_DASHBOARD_CHART_PARALLEL_SUCCESS, response: codeData });
                } else {
                    dispatch({ type: actionTypes.GET_DASHBOARD_CHART_PARALLEL_FAILURE, error: res.response.data });
                }
            } catch (e) {
                dispatch({ type: actionTypes.GET_DASHBOARD_CHART_PARALLEL_FAILURE, error: e.response && e.response.data });
            }
        } else {
            try {
                dispatch({ type: actionTypes.GET_DASHBOARD_CHART_REQUEST });
                const res = await Service.getChartsDashboardPython(param);
                if (res && res.status === 200) {
                    const codeData = res.data;
                    dispatch({ type: actionTypes.GET_DASHBOARD_CHART_SUCCESS, response: codeData });
                } else {
                    dispatch({ type: actionTypes.GET_DASHBOARD_CHART_FAILURE, error: res.response.data });
                }
            } catch (e) {
                dispatch({ type: actionTypes.GET_DASHBOARD_CHART_FAILURE, error: e.response && e.response.data });
            }
        }
    };
};

const getPythonCharts = param => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_DASHBOARD_CHART_REQUEST });
            const res = await Service.getChartsDashboardPython(param);
            if (res && res.status === 200) {
                const codeData = res.data;
                dispatch({ type: actionTypes.GET_DASHBOARD_CHART_SUCCESS, response: { [param.export_type]: codeData.chart } });
            } else {
                dispatch({ type: actionTypes.GET_DASHBOARD_CHART_FAILURE, error: res.response.data });
            }
        } catch (e) {
            dispatch({ type: actionTypes.GET_DASHBOARD_CHART_FAILURE, error: e.response && e.response.data });
        }
    };
};

const getFciChart = param => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_DASHBOARD_FCI_CHART_REQUEST });
            const res = await Service.getFciChart(param);
            if (res && res.status === 200) {
                const codeData = res.data;
                if (codeData.success) {
                    dispatch({ type: actionTypes.GET_DASHBOARD_FCI_CHART_SUCCESS, response: codeData });
                } else {
                    dispatch({ type: actionTypes.GET_DASHBOARD_FCI_CHART_FAILURE, error: codeData });
                }
            } else {
                dispatch({ type: actionTypes.GET_DASHBOARD_FCI_CHART_FAILURE, error: res.response.data });
            }
        } catch (e) {
            dispatch({ type: actionTypes.GET_DASHBOARD_FCI_CHART_FAILURE, error: e.response && e.response.data });
        }
    };
};

const getMap = param => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_DASHBOARD_MAP_CHART_REQUEST });
            const res = await Service.getMap(param);
            if (res && res.status === 200) {
                const codeData = res.data;
                if (codeData.success) {
                    dispatch({ type: actionTypes.GET_DASHBOARD_MAP_CHART_SUCCESS, response: codeData });
                } else {
                    dispatch({ type: actionTypes.GET_DASHBOARD_MAP_CHART_FAILURE, error: codeData });
                }
            } else {
                dispatch({ type: actionTypes.GET_DASHBOARD_MAP_CHART_FAILURE, error: res.response.data });
            }
        } catch (e) {
            dispatch({ type: actionTypes.GET_DASHBOARD_MAP_CHART_FAILURE, error: e.response && e.response.data });
        }
    };
};

const getHorizontalChartPython = param => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_DASHBOARD_HORIZONTAL_CHART_REQUEST });
            const res = await Service.getChartsDashboardPython(param);
            if (res && res.status === 200) {
                const codeData = res.data;
                dispatch({ type: actionTypes.GET_DASHBOARD_HORIZONTAL_CHART_SUCCESS, response: codeData });
            } else {
                dispatch({ type: actionTypes.GET_DASHBOARD_HORIZONTAL_CHART_FAILURE, error: res.response.data });
            }
        } catch (e) {
            dispatch({ type: actionTypes.GET_DASHBOARD_HORIZONTAL_CHART_FAILURE, error: e.response && e.response.data });
        }
    };
};

const getMasterFilter = (param, key, isRecommendationField, isRecommendationTable, isServerSearch = false) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_FILTER_PROJECT_REQUEST, key });
            const res = isRecommendationTable
                ? await getListForCommonFilter(param)
                : isRecommendationField
                  ? await Service.getRecommendationMasterFilter(param)
                  : await Service.getMasterFilter(param, key);
            if (res && res.status === 200) {
                const codeData = res.data;
                if (codeData.success) {
                    dispatch({
                        type: actionTypes.GET_FILTER_PROJECT_SUCCESS,
                        response: codeData,
                        key,
                        isServerSearch,
                        isRecommendationField: isRecommendationField || isRecommendationTable
                    });
                } else {
                    dispatch({ type: actionTypes.GET_FILTER_PROJECT_FAILURE, error: codeData, key });
                }
            } else {
                dispatch({ type: actionTypes.GET_FILTER_PROJECT_FAILURE, error: res.response.data, key });
            }
        } catch (e) {
            dispatch({ type: actionTypes.GET_FILTER_PROJECT_FAILURE, error: e.response && e.response.data, key });
        }
    };
};

const getAllLegents = param => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_LEGENTS_REQUEST });
            const res = await Service.getAllLegents(param);
            if (res && res.status === 200) {
                const codeData = res.data;
                if (codeData.success) {
                    dispatch({ type: actionTypes.GET_LEGENTS_SUCCESS, response: codeData });
                } else {
                    dispatch({ type: actionTypes.GET_LEGENTS_FAILURE, error: codeData });
                }
            } else {
                dispatch({ type: actionTypes.GET_LEGENTS_FAILURE, error: res.response.data });
            }
        } catch (e) {
            dispatch({ type: actionTypes.GET_LEGENTS_FAILURE, error: e.response && e.response.data });
        }
    };
};

const modifyFilter = (param, values, dashboardExtraFilters, backUpNames, backUpValues) => {
    return async dispatch => {
        let test = {
            param,
            values,
            dashboardExtraFilters,
            backUpNames,
            backUpValues
        };
        dispatch({ type: actionTypes.MODIFY_FILTER_REQUEST, response: test });
    };
};

const saveIndividualChartParams = params => {
    return async dispatch => {
        dispatch({ type: actionTypes.SAVE_INDIVIDUAL_CHART_PARAMS, response: params });
    };
};

const saveTempChartFilters = params => {
    return async dispatch => {
        dispatch({ type: actionTypes.SAVE_TEMP_CHART_FILTERS, response: params });
    };
};
const saveQueryTempChartFilters = params => {
    return async dispatch => {
        dispatch({ type: actionTypes.SAVE_QUERY_TEMP_CHART_FILTERS, response: params });
    };
};
const savePopUpData = data => {
    return async dispatch => {
        let test = {
            data
        };
        dispatch({ type: actionTypes.MODIFY_POP_UP_REQUEST, response: test });
    };
};

const getLandingPageData = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_LANDING_PAGE_REQUEST });
            const res = await Service.getLandingPageData(params);
            if (res && res.status === 200) {
                const responseData = res.data;
                dispatch({
                    type: actionTypes.GET_LANDING_PAGE_SUCCESS,
                    response: responseData
                });
            } else {
                dispatch({
                    type: actionTypes.GET_LANDING_PAGE_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_LANDING_PAGE_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getLandingPageReports = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_LANDING_PAGE_REPORT_REQUEST });
            const res = await Service.getLandingPageReports(params);
            if (res && res.status === 200) {
                const responseData = res.data;
                dispatch({
                    type: actionTypes.GET_LANDING_PAGE_REPORT_SUCCESS,
                    response: responseData
                });
            } else {
                dispatch({
                    type: actionTypes.GET_LANDING_PAGE_REPORT_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_LANDING_PAGE_REPORT_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getWidgetData = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_WIDGET_DATA_REQUEST });
            const res = await Service.getWidgetData(params);
            if (res && res.status === 200) {
                const responseData = res.data;
                dispatch({
                    type: actionTypes.GET_WIDGET_DATA_SUCCESS,
                    response: responseData
                });
            } else {
                dispatch({
                    type: actionTypes.GET_WIDGET_DATA_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_WIDGET_DATA_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const updateFullScreenValue = value => {
    return async dispatch => {
        try {
            dispatch({
                type: actionTypes.UPDATE_FULL_SCREEN_SUCCESS,
                response: value
            });
        } catch (e) {
            dispatch({
                type: actionTypes.UPDATE_FULL_SCREEN_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};
const toggleSecondChartView = value => {
    return async dispatch => {
        try {
            dispatch({
                type: actionTypes.UPDATE_IS_BUDGET_PRIORITY_VIEW_SUCCESS,
                response: value
            });
        } catch (e) {
            dispatch({
                type: actionTypes.UPDATE_IS_BUDGET_PRIORITY_VIEW_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const accordianOpen = value => {
    return async dispatch => {
        dispatch({
            type: actionTypes.UPDATE_TRACKER_MENU_SUCCESS,
            response: value
        });
    };
};
const setActiveMenu = value => {
    return async dispatch => {
        dispatch({
            type: actionTypes.SET_ACTIVE_MENU_SUCCESS,
            response: value
        });
    };
};
const updateDefaultProject = (value, fromSideMenu = false) => {
    return async dispatch => {
        const previousProjectId = localStorage.getItem("default_project");
        if (String(previousProjectId || "") !== String(value || "")) {
            invalidateDashboardSessionCache({ previousProjectId });
            if (value) {
                localStorage.setItem("default_project", value);
            }
        }
        dispatch({
            type: actionTypes.UPDATE_DEFAULT_PROJECT,
            response: value,
            payload: {
                fromSideMenu
            }
        });
    };
};
const toggleDashboardResetFlag = () => {
    return async dispatch => {
        dispatch({
            type: actionTypes.TOGGLE_DASHBOARD_RESET_FLAG
        });
    };
};
const updateMasterFilter = data => {
    return async dispatch => {
        dispatch({
            type: actionTypes.UPDATE_MASTER_FILTER,
            response: data
        });
    };
};
// Seed the applied-filter display sources ({ fields, options }) from an AI-assistant apply so the
// tag-area + FilterModal "all filters" view can resolve Otto's option ids -> display names without the
// user first opening each field's dropdown. See reducers.js SEED_AI_FILTER_LABELS.
const seedAiFilterLabels = seeds => {
    return async dispatch => {
        dispatch({
            type: actionTypes.SEED_AI_FILTER_LABELS,
            response: seeds
        });
    };
};
const SaveFilterQuery = data => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.SAVE_FILTER_REQUEST });
            const res = await Service.SaveFilterQuery(data);
            if (res && (res.status === 200 || res.status === 201)) {
                const responseData = res.data;
                if (data?.project_id) {
                    invalidateQueryFiltersForProject(data.project_id);
                }
                dispatch({
                    type: actionTypes.SAVE_FILTER_SUCCESS,
                    response: responseData
                });
            } else {
                dispatch({
                    type: actionTypes.SAVE_FILTER_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.SAVE_FILTER_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};
const getQuery = data => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_QUERY_REQUEST });
            const res = await Service.getQuery(data);
            if (res && res.status === 200) {
                const responseData = res.data;
                dispatch({
                    type: actionTypes.GET_QUERY_SUCCESS,
                    response: responseData
                });
            } else {
                dispatch({
                    type: actionTypes.GET_QUERY_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_QUERY_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};
const deleteQuery = (id, params) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.DELETE_QUERY_REQUEST });
            const res = await Service.deleteQuery(id);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({ type: actionTypes.DELETE_QUERY_SUCCESS, response: regionData });
                    if (params?.project_id) {
                        invalidateQueryFiltersForProject(params.project_id);
                    }
                    dispatch(getQuery({ ...params }));
                } else {
                    dispatch({ type: actionTypes.DELETE_QUERY_FAILURE, error: regionData });
                }
            } else {
                dispatch({
                    type: actionTypes.DELETE_QUERY_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.DELETE_QUERY_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};
const updateFilterQuery = (data, id, params) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.UPDATE_FILTER_REQUEST });
            const res = await Service.updateFilterQuery(data, id);
            if (res && (res.status === 200 || res.status === 201)) {
                const responseData = res.data;
                if (params?.project_id) {
                    invalidateQueryFiltersForProject(params.project_id);
                }
                dispatch({
                    type: actionTypes.UPDATE_FILTER_SUCCESS,
                    response: responseData
                });
                dispatch(getQuery({ ...params }));
            } else {
                dispatch({
                    type: actionTypes.UPDATE_FILTER_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.UPDATE_FILTER_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};
const updatedFilterName = data => {
    return async dispatch => {
        dispatch({
            type: actionTypes.UPDATE_FILTER_NAME,
            response: data
        });
    };
};
const addQueriesToFavorites = (data, params) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.ADD_QUERY_TO_FAVORITES_REQUEST });
            const res = await Service.addQueriesToFavorites(data);
            if (res && res.status === 200) {
                const dropdownData = res.data;
                dispatch({
                    type: actionTypes.ADD_QUERY_TO_FAVORITES_SUCCESS,
                    response: dropdownData
                });
                dispatch(getQuery({ ...params }));
            } else {
                dispatch({
                    type: actionTypes.ADD_QUERY_TO_FAVORITES_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.ADD_QUERY_TO_FAVORITES_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};
const assignFavoriteQueryToUsers = (data, params) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.ASSIGN_FAVORITE_QUERY_TO_USERS_REQUEST });
            const res = await Service.assignFavoriteQueryToUsers(data);
            if (res && res.status === 200) {
                const responseData = res.data;
                dispatch({
                    type: actionTypes.ASSIGN_FAVORITE_QUERY_TO_USERS_SUCCESS,
                    response: responseData
                });
                dispatch(getQuery({ ...params }));
            } else {
                dispatch({
                    type: actionTypes.ASSIGN_FAVORITE_QUERY_TO_USERS_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.ASSIGN_FAVORITE_QUERY_TO_USERS_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};
const getUsersByClientQuery = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_USERS_BY_CLIENT_QUERY_REQUEST });
            const res = await Service.getUsersByClientQuery(params);
            if (res && res.status === 200) {
                const usersList = res.data;
                dispatch({
                    type: actionTypes.GET_USERS_BY_CLIENT_QUERY_SUCCESS,
                    response: usersList
                });
            } else {
                dispatch({
                    type: actionTypes.GET_USERS_BY_CLIENT_QUERY_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_USERS_BY_CLIENT_QUERY_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};
const clearUserByClientQueryData = () => {
    return async dispatch => {
        dispatch({ type: actionTypes.CLEAR_USER_BY_CLIENT_QUERY_DATA });
    };
};

const getQueryFilterCreatedUsers = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_QUERY_FILTER_CREATED_USERS_REQUEST });
            const res = await Service.getQueryFilterCreatedUsers(params);
            if (res && res.status === 200) {
                dispatch({
                    type: actionTypes.GET_QUERY_FILTER_CREATED_USERS_SUCCESS,
                    response: res.data
                });
            } else {
                dispatch({
                    type: actionTypes.GET_QUERY_FILTER_CREATED_USERS_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_QUERY_FILTER_CREATED_USERS_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const clearQueryFilterCreatedUsers = () => {
    return dispatch => {
        dispatch({ type: actionTypes.CLEAR_QUERY_FILTER_CREATED_USERS });
    };
};

export const getQuickLinks = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_QUICK_LINKS_REQUEST });
            const res = await Service.getQuickLinks(params);
            if (res && res.status === 200) {
                const dropdownData = res.data;
                dispatch({
                    type: actionTypes.GET_QUICK_LINKS_SUCCESS,
                    response: dropdownData
                });
            } else {
                dispatch({
                    type: actionTypes.GET_QUICK_LINKS_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_QUICK_LINKS_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

export const addToQuickLinks = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.ADD_TO_QUICK_LINKS_REQUEST });
            const res = await Service.addToQuickLinks(params);
            if (res && res.status === 200) {
                const dropdownData = res.data;
                dispatch({
                    type: actionTypes.ADD_TO_QUICK_LINKS_SUCCESS,
                    response: dropdownData
                });
                showAlert(params.type === "action" ? "Added to Actions" : "Added to Bookmarks");
                dispatch(getQuickLinks({ user_id: params.user_id }));
            } else {
                dispatch({
                    type: actionTypes.ADD_TO_QUICK_LINKS_FAILURE,
                    error: res.response && res.response.data
                });
                showAlert(params.type === "action" ? "Oops..! Failed to add Action" : "Oops..! Failed to add Bookmarks");
            }
        } catch (e) {
            dispatch({
                type: actionTypes.ADD_TO_QUICK_LINKS_FAILURE,
                error: e.response && e.response.data
            });
            showAlert(params.type === "action" ? "Oops..! Failed to add Action" : "Oops..! Failed to add Bookmarks");
        }
    };
};
export const deleteQuickLinks = (id, userId, type) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.DELETE_QUICK_LINKS_REQUEST });
            const res = await Service.deleteQuickLinks(id);
            if (res && res.status === 200) {
                const dropdownData = res.data;
                dispatch({
                    type: actionTypes.DELETE_QUICK_LINKS_SUCCESS,
                    response: dropdownData
                });
                showAlert(type === "action" ? "Removed from Actions" : "Removed from Bookmarks");
                dispatch(getQuickLinks({ user_id: userId }));
            } else {
                dispatch({
                    type: actionTypes.DELETE_QUICK_LINKS_FAILURE,
                    error: res.response && res.response.data
                });
                showAlert(type === "action" ? "Oops..! Failed to remove Action" : "Oops..! Failed to remove Bookmarks");
            }
        } catch (e) {
            dispatch({
                type: actionTypes.DELETE_QUICK_LINKS_FAILURE,
                error: e.response && e.response.data
            });
            showAlert(type === "action" ? "Oops..! Failed to remove Action" : "Oops..! Failed to remove Bookmarks");
        }
    };
};
export const updateQuickLink = (id, params) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.UPDATE_QUICK_LINKS_REQUEST });
            const res = await Service.updateQuickLink(id, params);
            if (res && res.status === 200) {
                const dropdownData = res.data;
                dispatch({
                    type: actionTypes.UPDATE_QUICK_LINKS_SUCCESS,
                    response: dropdownData
                });
                dispatch(getQuickLinks({ user_id: params.user_id }));
            } else {
                dispatch({
                    type: actionTypes.UPDATE_QUICK_LINKS_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.UPDATE_QUICK_LINKS_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};
const setInitialFiltersApplied = () => {
    return async dispatch => {
        dispatch({ type: `SET_INITIAL_FILTERS_APPLIED` });
    };
};
const getDashboardLeaseAssetsCount = param => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_DASHBOARD_MAP_LEASE_ASSET_COUNT_REQUEST });
            const res = await Service.getDashboardLeaseAssetsCount(param);
            if (res && res.status === 200) {
                const codeData = res.data;
                if (codeData.success) {
                    const value = {
                        leaseCount: codeData?.lease_count ?? 0,
                        assetCount: codeData?.asset_count ?? 0,
                        mobileAssetCount: codeData?.mobile_asset_count ?? 0,
                        imageCount: codeData?.image_count ?? 0,
                        docCount: codeData?.doc_count ?? 0
                    };
                    dispatch({ type: actionTypes.GET_DASHBOARD_MAP_LEASE_ASSET_COUNT_SUCCESS, response: value });
                    return value;
                } else {
                    dispatch({ type: actionTypes.GET_DASHBOARD_MAP_LEASE_ASSET_COUNT_FAILURE, error: codeData });
                }
            } else {
                dispatch({ type: actionTypes.GET_DASHBOARD_MAP_LEASE_ASSET_COUNT_FAILURE, error: res.response.data });
            }
        } catch (e) {
            dispatch({ type: actionTypes.GET_DASHBOARD_MAP_LEASE_ASSET_COUNT_FAILURE, error: e.response && e.response.data });
        }
    };
};

export const getChartDynamicFields = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_CHART_DYNAMIC_FIELDS_REQUEST });
            const res = await Service.getChartDynamicFields(params);
            if (res && res.status === 200) {
                const dropdownData = res.data;
                dispatch({
                    type: actionTypes.GET_CHART_DYNAMIC_FIELDS_SUCCESS,
                    response: dropdownData
                });
                return dropdownData;
            } else {
                dispatch({
                    type: actionTypes.GET_CHART_DYNAMIC_FIELDS_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_CHART_DYNAMIC_FIELDS_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const actions = {
    getDashboard,
    getFciChart,
    getMap,
    getMasterFilter,
    getAllLegents,
    modifyFilter,
    savePopUpData,
    getFcaChartExcelExport,
    getFciChartExcelExport,
    getHorizontalChartExport,
    getLandingPageData,
    getLandingPageReports,
    getWidgetData,
    updateFullScreenValue,
    toggleSecondChartView,
    accordianOpen,
    setActiveMenu,
    getChartsDashboardPython,
    getHorizontalChartPython,
    updateDefaultProject,
    toggleDashboardResetFlag,
    getPythonCharts,
    saveIndividualChartParams,
    updateMasterFilter,
    seedAiFilterLabels,
    saveTempChartFilters,
    clearDashboardData,
    SaveFilterQuery,
    getQuery,
    deleteQuery,
    updateFilterQuery,
    updatedFilterName,
    saveQueryTempChartFilters,
    addQueriesToFavorites,
    assignFavoriteQueryToUsers,
    getUsersByClientQuery,
    clearUserByClientQueryData,
    getQueryFilterCreatedUsers,
    clearQueryFilterCreatedUsers,
    setInitialFiltersApplied,
    getDashboardLeaseAssetsCount,
    getChartDynamicFields
};
export default actions;
